// extracted by mini-css-extract-plugin
export default {"Editor":"Editor--it-4a"};